import React from 'react'

const Manual_filtrar_productos_dashboard_clau = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          ¿Cómo filtrar productos desde el Dashboard de Clau.io?
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Aprende a aplicar filtros dentro del Dashboard de Clau.io para encontrar y gestionar tus productos fácilmente.
        </p>
        <iframe
          src="https://scribehow.com/embed/Como_filtrar_productos_desde_el_Dashboard_de_Clauio__AYCqjYXtQLiB4rldUcYnOw?as=scrollable"
          className="scribe-iframe-general-131"
          width="100%"
          height="4900"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_filtrar_productos_dashboard_clau
